import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { OrderPage, shareToken } from "./components/OrderPage";
import { LangProvider } from "./lib/i18n";
import "./styles.css";

// A share link (/d/<token>) opens the public order page: no login, no app.
const token = shareToken(window.location.pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {token ? (
      <OrderPage token={token} />
    ) : (
      <LangProvider>
        <App />
      </LangProvider>
    )}
  </StrictMode>,
);
